import React from 'react';
import { ArrowLeft, Clock } from 'lucide-react';

/**
 * Shown where a phone-app feature has no data in RLE yet. Never an empty list —
 * an empty list looks exactly like a bug.
 */
const NotAvailableYet: React.FC<{ title?: string; message?: string; onBack?: () => void }> = ({
  title = 'Not available yet',
  message = 'This part of the app is not available yet.',
  onBack,
}) => (
  <div className="flex flex-col h-full">
    {onBack && (
      <header className="sticky top-0 bg-background border-b border-border z-10">
        <div className="flex items-center px-4 h-14 gap-2">
          <button onClick={onBack} className="p-2 -ml-2 text-muted-foreground hover:text-foreground" aria-label="Back">
            <ArrowLeft className="h-5 w-5" />
          </button>
        </div>
      </header>
    )}
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center" data-testid="not-available-yet">
      <Clock className="h-12 w-12 text-muted-foreground mb-4" />
      <h3 className="text-lg font-medium text-foreground mb-1">{title}</h3>
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  </div>
);

export default NotAvailableYet;
